/* istanbul ignore file */

// deps
import PropTypes from "prop-types";
import { useState, useContext } from "react";
// @ts-ignore
import { RendererContext } from "@splitfire-agency/raiden-le-editeur/dist/Renderers";
import { Box, Image, Text } from "@chakra-ui/react";

// libraries
import { filesGetSrc } from "../../../helpers/files";
import { useIntl } from "react-intl";
import generateAdminUrl from "../../../libraries/utils/generateAdminUrl";

export function FilesEditorImageBlockChakra(props) {
  const { block } = props;

  const { document, language } = useContext(RendererContext);

  const content =
    block.content.intl[language.key] ?? block.content.intl[document.language];

  const [hasError, setHasError] = useState(false);

  const intl = useIntl();

  return (
    <>
      {hasError || !content?.src ? (
        <Image
          src={generateAdminUrl({
            id: "@admin.internal-assets",
            parameters: {
              filePath: "splashes/default.png",
            },
          })}
          alt={intl.formatMessage({ defaultMessage: "Placeholder" })}
        />
      ) : (
        <Box>
          <Image
            alt={content?.alt}
            title={content?.name}
            onLoad={function () {
              setHasError(false);
            }}
            onError={function () {
              setHasError(true);
            }}
            src={filesGetSrc({ content })}
          />

          {content?.caption && <Text mt="0.5rem">{content.caption}</Text>}
        </Box>
      )}
    </>
  );
}

FilesEditorImageBlockChakra.propTypes = {
  block: PropTypes.object,
};
